import styled from 'styled-components'

import colors from '@settings/styleSettings'

export const Container = styled.div``

export const CloseIcon = styled.div`
  cursor: pointer;
  color: ${colors.strongGray};
`

export const ButtonArea = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 10px;
  flex-direction: column;
`
export const Title = styled.div`
  font-size: 30px;
  margin: 16px 0 40px 0;
  font-family: Circular-Std-Bold;
`
export const DetailContainer = styled.div`
  font-size: 14px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 10px;
  padding-bottom: 15px;
  border-top: 1px solid ${colors.softGray};
`
export const HideDetail = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`
export const Detail = styled.div`
  font-size: 14px;
  display: flex;
  flex-direction: column;
  width: 100%;
  color: ${colors.strongRed};
  word-break: break-word; 
`
export const Bold = styled.div`
  font-family: Circular-Std-Bold;
`
